import Template from './Image.hbs';
import Button from 'views/components/wysiwyg/parts/buttons/Button';
import UploadImageModal from 'views/components/wysiwyg/modals/uploadImage/UploadImage';
import ImageTemplate from 'views/components/wysiwyg/elements/image.hbs';
import UploadModel from 'models/UploadModel'
import PastedImageUploader from 'util/PastedImageUploader'

export default class Image extends Button {

    // Built-in TinyMCE command to add an <img src="…"> at the current cursor position
    command = 'insertImage'

    initializeButton() {
        this.icon = Template();
        this.tooltip = window.i18n.gettext('Image');
    }

    addCommands(editorObject) {
        const editor = editorObject.editor;
        const customEl = editorObject.customEl;
        const customSH = editorObject.customSH;

        // Add the command for inserting images.
        editor.addCommand(this.command, () => {
            this.openImageUploadModal(editor, customEl)
        });

        // Create the state handler for this block element
        customSH.blockElementHandler(

            // Listen to command: insertImage
            this.command,

            // Use the ImageTemplate template to indentify the block
            // Note that ImageTemplate doesn't have a newline at end of file.
            // If it did, this newline would be inserted into the editor,
            // adding an unwanted empty line after the inserted content.
            ImageTemplate(),

            // Pass the editor with it
            editor,
        );

        // PastedImageUploader processes image files that get pasted into the editor directly.
        // Not to be confused with pasting HTML that contains images, which is handled in the
        // pastePostProcessImageElement function.
        const pastedImageUploadModel = new UploadModel({
            uploadType: 'wysiwyg-image',
            doNotCreateInputElement: true,
            customUploadStatusHandler: this.wysiwyg.onChangeImageUploadStatus,
        })
        const pastedImageUploader = new PastedImageUploader(pastedImageUploadModel)
        editor.on('paste', pastedImageUploader.onPaste)

        editor.on('dblclick', ({target}) => {
            if (target.nodeName === 'IMG' && !target.classList.contains('js-expression')) {
                this.openImageUploadModal(editor, customEl)
            }
        })
    }

    openImageUploadModal(editor, customElement) {
        customElement.modalComponentElement(

            // Set modal title
            window.i18n.gettext('Upload an image'),

            // Pass the to be inserted template
            ImageTemplate,

            // Define the to-be-opened modal(view)
            UploadImageModal,

            // Pass the editor object
            editor,

            // Image upload/edit options
            {
                // If true, don't show alignment or size adjustments options for image elements.
                simpleImageStyling: this.wysiwyg.simpleImageStyling
            },
        )
    }

}
